export default __webpack_public_path__ + "static/media/jojoGame.1c8e8ee4.png";